import { render } from "./DropdownType.vue?vue&type=template&id=4d742682"
import script from "./DropdownType.vue?vue&type=script&lang=js"
export * from "./DropdownType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biwabits/Documents/ProjectDev/yayasan-ahmadyanibinjai/form-ppdb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__